// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"99b3b4d9","769":"0df69f1c"}[chunkId] + ".chunk.js";
};